import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { FeeConfig } from 'src/app/domain/registration/models/fee-config/IFeeConfig';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { FEE_CONFIG_CRUD_CONFIG } from './crud-config';
import { FeeConfigService } from './fee-config.service';
import { FeeConfigRequest, FeeFormPayloadRequest } from 'src/app/domain/registration/models/fee-config/IFeeConfigRequest';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-fee-config-dialog',
    templateUrl: './fee-config-dialog.component.html',
    styleUrls: ['./fee-config-dialog.component.sass']
})
export class FeeConfigDialogComponent extends AbstractCrudCES<FeeConfig> implements OnInit {
    feeForm: FormGroup;
    isLoading = false;
    currentFees: FeeConfig | null = null;
    dataMerchant: any;
    idMerchantInject: string;
    private destroy$ = new Subject<void>();
    public override config: IFieldConfig[] = FEE_CONFIG_CRUD_CONFIG;

    constructor(
        public override fb: FormBuilder,
        private dialogRef: MatDialogRef<FeeConfigDialogComponent>,
        private feeConfigService: FeeConfigService,
        private toastService: ToastService,
        @Inject(MAT_DIALOG_DATA) public idMerchant: any
    ) {
        super(fb);
        if (idMerchant) {
            this.idMerchantInject = idMerchant;
            this.typeCes = TypeCesEnum.SHOW;
        }
        this.feeForm = this.createForm();
    }

    override ngOnInit(): void {
        if (this.idMerchantInject) {
            this.loadFees(this.idMerchantInject);
        }
        this.setupExclusiveFieldSubscriptions();
    }

    private createForm(): FormGroup {
        const group: any = {
            numero_cnpj: ['', [Validators.required]],
            pixCashin: ['', []],
            pixStaticCashin: ['', []],
            boletoCashin: ['', []],
            pixCashout: ['', []],
            pixCashinSemStatus: ['', []],
            pixCashinValue: ['', []],
            pixStaticCashinValue: ['', []],
            boletoCashinValue: ['', []],
            pixCashoutValue: ['', []],
            pixCashinSemStatusValue: ['', []],
        };
        return this.fb.group(group);
    }

    private loadFees(id: string) {
        this.feeConfigService.getFeeConfig(id).subscribe({
            next: (response) => {
                this.isLoading = false;
                this.dataMerchant = response;
                this.buildForm();
                this.toastService.showSuccess('Tarifas configuradas com sucesso!');
            },
            error: (error: any) => {
                console.error('Erro ao atualizar tarifas:', error);
                this.isLoading = false;
                this.toastService.showError(error);
            }
        });
    }

    private buildForm() {
        const patchValues: { [key: string]: string | number | null } = {};
        this.dataMerchant.splits.forEach((service: any) => {
            const formControlName = service.tipo_transacao;
            const valorApi = service.valor;

            if (valorApi && this.feeForm.get(formControlName) && service.tipo === 'percentual') {
                const valorDecimal = parseFloat(valorApi);
                const valorPercentual = valorDecimal * 100;
                patchValues[formControlName] = valorPercentual;
            }

            if (valorApi && this.feeForm.get(formControlName + 'Value') && service.tipo === 'valor') {
                const valorDecimal = parseFloat(valorApi);
                patchValues[formControlName + 'Value'] = valorDecimal;
            }
        });
        patchValues['numero_cnpj'] = this.dataMerchant.numero_cnpj;
        this.feeForm.patchValue(patchValues);
    }

    onSubmit(): void {
        if (this.feeForm.valid) {
            this.isLoading = true;
            const formValue = this.feeForm.value;
            const formData: FeeFormPayloadRequest = {
                numero_cnpj: formValue.numero_cnpj,
                pixCashin: formValue.pixCashin,
                pixStaticCashin: formValue.pixStaticCashin,
                boletoCashin: formValue.boletoCashin,
                pixCashout: formValue.pixCashout,
                pixCashinSemStatus: formValue.pixCashinSemStatus,

                pixCashinValue: formValue.pixCashinValue,
                pixStaticCashinValue: formValue.pixStaticCashinValue,
                boletoCashinValue: formValue.boletoCashinValue,
                pixCashoutValue: formValue.pixCashoutValue,
                pixCashinSemStatusValue: formValue.pixCashinSemStatusValue,
            };

            console.log("RESULTADO:", formValue)
            this.feeConfigService.createFeeConfig(formData as FeeFormPayloadRequest).subscribe({
                next: (response) => {
                    this.isLoading = false;
                    this.toastService.showSuccess('Tarifas configuradas com sucesso!');
                    this.dialogRef.close(formValue);
                },
                error: (error: any) => {
                    console.error('Erro ao atualizar tarifas:', error);
                    this.isLoading = false;
                    this.toastService.showError('Erro ao atualizar tarifas', error);
                }
            });
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }


    private isFilled(value: any): boolean {
        return value !== null && value !== undefined && value !== '';
    }


    private setupExclusiveFieldSubscriptions(): void {

        const exclusivePairs = [
            ['pixCashin', 'pixCashinValue'],
            ['pixStaticCashin', 'pixStaticCashinValue'],
            ['boletoCashin', 'boletoCashinValue'],
            ['pixCashout', 'pixCashoutValue'],
            ['pixCashinSemStatus', 'pixCashinSemStatusValue']
        ];

        for (const [percentControlName, valueControlName] of exclusivePairs) {

            const percentControl = this.feeForm.get(percentControlName);
            const valueControl = this.feeForm.get(valueControlName);

            if (!percentControl || !valueControl) {
                console.warn(`Controles ${percentControlName} ou ${valueControlName} não encontrados.`);
                continue;
            }

            percentControl.valueChanges.pipe(
                takeUntil(this.destroy$)
            ).subscribe(value => {
                if (this.isFilled(value)) {

                    valueControl.patchValue(null, { emitEvent: false });
                }
            });

            valueControl.valueChanges.pipe(
                takeUntil(this.destroy$)
            ).subscribe(value => {
                if (this.isFilled(value)) {
                    percentControl.patchValue(null, { emitEvent: false });
                }
            });
        }
    }
}
